<template>
  <div
    class="card mb-25 border-0 rounded-0 bg-white to-do-list-box letter-spacing"
  >
    <div
      class="card-body pt-0 pb-15 pb-sm-20 pb-md-25 pb-lg-30 ps-15 pe-15 ps-sm-20 pe-sm-20 ps-md-25 pe-md-25 ps-lg-30 pe-lg-30"
    >
      <div
        class="card-head bg-white d-md-flex align-items-center justify-content-between pt-15 pb-15 ps-15 pe-15 ps-sm-20 pe-sm-20 ps-md-25 pe-md-25 ps-lg-30 pe-lg-30 mb-4"
      >
        <button class="btn btn-primary" @click="openModal()">
          + Lier un store
        </button>
      </div>

      <!-- TABLE -->
      <div class="table-responsive table-scroll-mobile">
        <table class="table text-nowrap align-middle mb-0">
          <thead>
            <tr class="bg-gray-100">
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Store
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Domain
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Webhook URL
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Date
              </th>
              <th
                scope="col"
                class="text-uppercase fw-medium shadow-none text-body-tertiary fs-13 pt-0"
              >
                Actions
              </th>
            </tr>
          </thead>

          <tbody>
            <tr v-for="s in stores" :key="s.id">
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ s.shopify_name }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <a :href="s.shopify_domain" target="_blank">{{
                  s.shopify_domain
                }}</a>
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ s.shopify_key }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                {{ getDate(s.created_at) }}
              </td>
              <td class="shadow-none lh-1 fw-medium text-black-emphasis">
                <button
                  class="btn btn-sm btn-danger"
                  @click="removeStore(s.id)"
                >
                  🗑
                </button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <!-- MODAL -->
  </div>
  <div class="modal fade" id="addShopifyModal" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content p-15 p-md-40">
        <div class="modal-header">
          <h1 class="modal-title fs-5">
            {{ editing ? "Modifier store" : "Ajouter store" }}
          </h1>
          <button class="btn-close" @click="closeModal"></button>
        </div>

        <div class="modal-body">
          <input
            v-model="form.shopify_name"
            class="form-control mb-3"
            placeholder="Nom du store"
          />
          <input
            v-model="form.shopify_domain"
            class="form-control mb-3"
            placeholder="Domain"
          />
          <input
            v-model="form.shopify_secret"
            class="form-control mb-3"
            placeholder="Webhook secret"
          />
        </div>

        <div class="modal-footer">
          <button class="btn btn-secondary" @click="closeModal">Annuler</button>
          <button class="btn btn-primary" @click="submit">Appliquer</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useAppToast } from "@/composables/useAppToast";
import api from "@/utils/axios";
import { Modal } from "bootstrap";
import moment from "moment";
import Swal from "sweetalert2";
import { ref, onMounted } from "vue";

const stores = ref<any[]>([]);
const showModal = ref(false);
const editing = ref(false);
const editId = ref<number | null>(null);

const { showToast } = useAppToast();

const form = ref({
  shopify_name: "",
  shopify_domain: "",
  shopify_secret: "",
});

const loadStores = async () => {
  const { data } = await api.get("/api/auth/client/shopify");
  stores.value = data.data;
};

onMounted(loadStores);

const openModal = (store: any = null) => {
  editing.value = !!store;

  if (store) {
    editId.value = store.id;
    form.value = { ...store };
  } else {
    editId.value = null;
    form.value = { shopify_name: "", shopify_domain: "", shopify_secret: "" };
  }

  const modalEl = document.getElementById("addShopifyModal");
  if (modalEl) {
    const modal = new Modal(modalEl);
    showModal.value = true;

    modal.show();
  }
};

const submit = async () => {
  try {
    let res;

    if (editing.value && editId.value) {
      res = await api.put(
        `/api/auth/client/shopify/${editId.value}`,
        form.value
      );

      if (res.data && res.data.success) {
        showToast("Store modifié avec succès", "success");
        closeModal();
        await loadStores();
      } else if (res.data && res.data.success === false) {
        showToast(
          res.data.message ?? "Erreur lors de la modification du store",
          "error"
        );
      }
    } else {
      res = await api.post("/api/auth/client/shopify", form.value);
      if (res.data && res.data.success) {
        showToast("Store ajouté avec succès", "success");
        closeModal();
        await loadStores();
      } else if (res.data && res.data.success === false) {
        console.log("Response error:", res);
        showToast(
          res.data.message ?? "Erreur lors de l'ajout du store",
          "error"
        );
      }
    }

    console.log("Response:", res);
  } catch (error) {
    console.error("Submit error:", error);

    // optional: show toast / alert
    // showToast(error.response?.data?.message || "Something went wrong", "error");
  }
};

const removeStore = async (id: number) => {
  Swal.fire({
    text: "Vous voulez supprimer ce store ?",
    icon: "warning",
    showCancelButton: true,
    confirmButtonColor: "#3085d6",
    cancelButtonColor: "#d33",
    confirmButtonText: "Oui, supprimer!",
  }).then(async (result: any) => {
    if (result.isConfirmed) {
      await api.delete(`/api/auth/client/shopify/${id}`);
      loadStores();
    }
  });
};

function getDate(value) {
  if (value) return moment(String(value)).format("YYYY-MM-DD HH:mm");
  else return "";
}

const addShopifyModal = ref<HTMLElement | null>(null);
let modalInstance: Modal | null = null;

onMounted(() => {
  // if (addShopifyModal.value) {
  //   modalInstance = new Modal(addShopifyModal.value, {
  //     backdrop: "static",
  //     keyboard: false,
  //   });
  // }
});

const closeModal = () => {
  // modalInstance?.hide();
  console.log("Closing modal");
  // const modalEl = document.getElementById("addShopifyModal");
  // console.log("Modal element:", modalEl);
  // if (modalEl) {
  //   const modal = new Modal(modalEl);
  //   modal.hide();
  // }

  const modalEl = document.getElementById("addShopifyModal");
  const instance = Modal.getInstance(modalEl);
  instance?.hide();
};
</script>
